import xss, { safeAttrValue as XssSafeAttrValue, friendlyAttrValue, } from 'xss';
var commonGlobalAttrs = ['style', 'dir', 'class'];
function safeAttrValue(tag, name, value, cssFilter) {
    if (name === 'href') {
        var friendlyValue = friendlyAttrValue(value);
        if (friendlyValue.startsWith('${') && friendlyValue.indexOf('}') !== -1) {
            return value;
        }
        return friendlyValue;
    }
    return XssSafeAttrValue(tag, name, value, cssFilter);
}
var validators = [
    function (url) { return url.startsWith('//'); },
    function (url) { return url.startsWith('http://'); },
    function (url) { return url.startsWith('https://'); },
    function (url) { return url.startsWith('tel:'); },
    function (url) { return url.startsWith('mailto:'); },
    function (url) { return url.startsWith('#'); },
    function (url) { return url.startsWith('${') && url.indexOf('}') !== -1; },
];
var isSupportedUrl = function (url) {
    var isSupported = false;
    var lowercaseUrl = url.toLowerCase();
    for (var _i = 0, validators_1 = validators; _i < validators_1.length; _i++) {
        var validator = validators_1[_i];
        if (validator(lowercaseUrl)) {
            isSupported = true;
            break;
        }
    }
    return isSupported;
};
var LEAVE_ELEMENT = undefined;
var REMOVE_ELEMENT = '';
export var getCleanUserHtmlWithMetadata = function (html) {
    var removedTags = {};
    var removedAttributes = {};
    var removedInvalidAttrValues = {};
    var onIgnoreTag = function (tag) {
        removedTags[tag] = tag;
        return REMOVE_ELEMENT;
    };
    var onTagAttr = function (tag, attr, value) {
        if (tag === 'a' && attr === 'href') {
            if (!isSupportedUrl(value)) {
                var tagAttrPair = tag + "," + attr;
                if (!removedInvalidAttrValues[tagAttrPair]) {
                    removedInvalidAttrValues[tagAttrPair] = [];
                }
                removedInvalidAttrValues[tagAttrPair].push(value);
                return REMOVE_ELEMENT;
            }
        }
        return LEAVE_ELEMENT;
    };
    var onIgnoreTagAttr = function (tag, attr) {
        var tagAttrPair = tag + "," + attr;
        removedAttributes[tagAttrPair] = tagAttrPair;
        return REMOVE_ELEMENT;
    };
    var cleanHtml = xss(html, {
        whiteList: {
            h1: commonGlobalAttrs,
            h2: commonGlobalAttrs,
            h3: commonGlobalAttrs,
            h4: commonGlobalAttrs,
            h5: commonGlobalAttrs,
            div: commonGlobalAttrs,
            span: commonGlobalAttrs,
            p: commonGlobalAttrs,
            a: ['style', 'dir', 'target', 'rel', 'href'],
            ol: ['style', 'dir', 'class', 'start'],
            ul: commonGlobalAttrs,
            li: commonGlobalAttrs,
            s: commonGlobalAttrs,
            b: commonGlobalAttrs,
            i: commonGlobalAttrs,
            u: commonGlobalAttrs,
            bdi: ['style', 'dir'],
            br: [],
            pre: commonGlobalAttrs,
            table: [
                'style',
                'class',
                'align',
                'role',
                'cellpadding',
                'cellspacing',
                'width',
                'border',
            ],
            tr: ['style', 'class'],
            td: ['style', 'class', 'align', 'valign', 'width'],
            tbody: ['style', 'class'],
            thead: ['style', 'class'],
            img: [
                'style',
                'class',
                'src',
                'width',
                'height',
                'border',
                'alt',
                'usemap',
                'dir',
                'target',
                'rel',
            ],
        },
        onIgnoreTag: onIgnoreTag,
        onTagAttr: onTagAttr,
        onIgnoreTagAttr: onIgnoreTagAttr,
        safeAttrValue: safeAttrValue,
        css: false,
    });
    return {
        html: cleanHtml,
        meta: {
            removedTags: Object.values(removedTags),
            removedAttributes: Object.values(removedAttributes),
            removedInvalidAttrValues: removedInvalidAttrValues,
        },
    };
};
//# sourceMappingURL=cleanUserHtml.js.map